import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface KeyboardShortcut {
  key: string;
  ctrl?: boolean;
  shift?: boolean;
  alt?: boolean;
  meta?: boolean;
  action: string;
  description: string;
}

@Injectable({
  providedIn: 'root',
})
export class KeyboardShortcutsService {
  private shortcuts = new Map<string, () => void>();
  private shortcutsSubject = new Subject<KeyboardShortcut[]>();
  public shortcuts$ = this.shortcutsSubject.asObservable();

  private registeredShortcuts: KeyboardShortcut[] = [];

  constructor() {
    this.setupGlobalListener();
  }

  private setupGlobalListener(): void {
    document.addEventListener('keydown', (event) => {
      // Don't trigger shortcuts when typing in inputs, textareas, or contenteditable
      const target = event.target as HTMLElement;
      if (
        target.tagName === 'INPUT' ||
        target.tagName === 'TEXTAREA' ||
        target.isContentEditable ||
        (target.closest('[contenteditable="true"]') !== null)
      ) {
        return;
      }

      const key = this.getKeyString(event);
      const handler = this.shortcuts.get(key);
      if (handler) {
        event.preventDefault();
        handler();
      }
    });
  }

  private getKeyString(event: KeyboardEvent): string {
    const parts: string[] = [];
    if (event.ctrlKey || event.metaKey) parts.push('ctrl');
    if (event.shiftKey) parts.push('shift');
    if (event.altKey) parts.push('alt');
    parts.push(event.key.toLowerCase());
    return parts.join('+');
  }

  register(shortcut: KeyboardShortcut, handler: () => void): void {
    const key = this.buildKeyString(shortcut);
    this.shortcuts.set(key, handler);
    this.registeredShortcuts.push(shortcut);
    this.shortcutsSubject.next([...this.registeredShortcuts]);
  }

  unregister(action: string): void {
    const shortcut = this.registeredShortcuts.find((s) => s.action === action);
    if (shortcut) {
      const key = this.buildKeyString(shortcut);
      this.shortcuts.delete(key);
      this.registeredShortcuts = this.registeredShortcuts.filter(
        (s) => s.action !== action
      );
      this.shortcutsSubject.next([...this.registeredShortcuts]);
    }
  }

  private buildKeyString(shortcut: KeyboardShortcut): string {
    const parts: string[] = [];
    if (shortcut.ctrl || shortcut.meta) parts.push('ctrl');
    if (shortcut.shift) parts.push('shift');
    if (shortcut.alt) parts.push('alt');
    parts.push(shortcut.key.toLowerCase());
    return parts.join('+');
  }

  getShortcuts(): KeyboardShortcut[] {
    return [...this.registeredShortcuts];
  }
}



































